import { render, staticRenderFns } from "./title-text-box.vue?vue&type=template&id=107f76c2&scoped=true&"
import script from "./title-text-box.vue?vue&type=script&lang=js&"
export * from "./title-text-box.vue?vue&type=script&lang=js&"
import style0 from "./title-text-box.vue?vue&type=style&index=0&id=107f76c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107f76c2",
  null
  
)

export default component.exports